/* B Shocked Electrical — Premium Effects v1.0 */
(function () {
  'use strict';

  /* ─── ELECTRIC PARTICLE CANVAS ─────────────────────────────────── */
  function initElectricCanvas() {
    var hero = document.getElementById('heroSlider');
    if (!hero) return;

    var canvas = document.createElement('canvas');
    canvas.id = 'bseParticleCanvas';
    hero.insertBefore(canvas, hero.firstChild);

    var ctx = canvas.getContext('2d');
    var N = 22, MAX_D = 210;
    var W, H, nodes = [], sparks = [], raf;

    function resize() {
      var r = hero.getBoundingClientRect();
      W = canvas.width = r.width || window.innerWidth;
      H = canvas.height = r.height || 600;
    }

    function mkNode() {
      return {
        x: Math.random() * W,
        y: Math.random() * H,
        vx: (Math.random() - 0.5) * 0.28,
        vy: (Math.random() - 0.5) * 0.28
      };
    }

    resize();
    for (var i = 0; i < N; i++) nodes.push(mkNode());
    window.addEventListener('resize', resize);

    function triggerSpark() {
      var best = null, bestD = Infinity;
      for (var i = 0; i < nodes.length; i++) {
        for (var j = i + 1; j < nodes.length; j++) {
          var d = Math.hypot(nodes[i].x - nodes[j].x, nodes[i].y - nodes[j].y);
          if (d < MAX_D && d < bestD) { bestD = d; best = [i, j]; }
        }
      }
      if (best) sparks.push({ a: best[0], b: best[1], life: 1 });
    }

    setInterval(triggerSpark, 1600 + Math.random() * 1400);

    function drawZigzag(x1, y1, x2, y2, alpha, lw) {
      var segs = 8;
      ctx.beginPath();
      ctx.moveTo(x1, y1);
      for (var i = 1; i < segs; i++) {
        var t = i / segs;
        ctx.lineTo(
          x1 + (x2 - x1) * t + (Math.random() - 0.5) * 16,
          y1 + (y2 - y1) * t + (Math.random() - 0.5) * 16
        );
      }
      ctx.lineTo(x2, y2);
      ctx.strokeStyle = 'rgba(245,196,0,' + alpha + ')';
      ctx.lineWidth = lw || 1;
      ctx.stroke();
    }

    function loop() {
      ctx.clearRect(0, 0, W, H);

      nodes.forEach(function (n) {
        n.x += n.vx; n.y += n.vy;
        if (n.x < 0 || n.x > W) n.vx *= -1;
        if (n.y < 0 || n.y > H) n.vy *= -1;
      });

      /* soft connection lines */
      for (var i = 0; i < nodes.length; i++) {
        for (var j = i + 1; j < nodes.length; j++) {
          var a = nodes[i], b = nodes[j];
          var d = Math.hypot(a.x - b.x, a.y - b.y);
          if (d < MAX_D) {
            var alpha = (1 - d / MAX_D) * 0.09;
            ctx.beginPath();
            ctx.moveTo(a.x, a.y);
            ctx.lineTo(b.x, b.y);
            ctx.strokeStyle = 'rgba(245,196,0,' + alpha + ')';
            ctx.lineWidth = 0.7;
            ctx.stroke();
          }
        }
      }

      /* node dots */
      nodes.forEach(function (n) {
        ctx.beginPath();
        ctx.arc(n.x, n.y, 1.3, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(245,196,0,0.22)';
        ctx.fill();
      });

      /* spark bolts */
      ctx.save();
      sparks = sparks.filter(function (s) { return s.life > 0; });
      sparks.forEach(function (s) {
        var a = nodes[s.a], b = nodes[s.b];
        ctx.shadowBlur = 12;
        ctx.shadowColor = '#F5C400';
        drawZigzag(a.x, a.y, b.x, b.y, s.life * 0.8, 1.4);
        ctx.shadowBlur = 0;
        s.life -= 0.038;
      });
      ctx.restore();

      raf = requestAnimationFrame(loop);
    }

    loop();
  }

  /* ─── 3D CARD TILT ──────────────────────────────────────────────── */
  function initTilt() {
    document.querySelectorAll('.cat-tile, .why-card, .stat-item').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
        var dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
        var rotX = -dy * 6;
        var rotY = dx * 6;
        var mx = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%';
        var my = ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%';
        el.style.setProperty('--mx', mx);
        el.style.setProperty('--my', my);
        el.style.transition = 'transform 0.06s linear';
        el.style.transform = 'perspective(900px) rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg) translateZ(3px)';
      });

      el.addEventListener('mouseleave', function () {
        el.style.transition = 'transform 0.45s cubic-bezier(0.16,1,0.3,1)';
        el.style.transform = 'perspective(900px) rotateX(0deg) rotateY(0deg) translateZ(0)';
        setTimeout(function () {
          el.style.transform = '';
          el.style.transition = '';
        }, 450);
      });
    });
  }

  /* ─── MAGNETIC BUTTONS ──────────────────────────────────────────── */
  function initMagnetic() {
    document.querySelectorAll('.slide-btn-primary, .btn-primary, .btn-primary-blue, .btn-primary-solar').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
        var dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
        el.style.transition = 'transform 0.15s ease';
        el.style.transform = 'translate(' + (dx * 5) + 'px, ' + (dy * 3) + 'px)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transition = 'transform 0.45s cubic-bezier(0.16,1,0.3,1)';
        el.style.transform = '';
      });
    });
  }

  /* ─── LIVE ACTIVITY NOTIFICATIONS ──────────────────────────────── */
  function initLiveActivity() {
    var activities = [
      { icon: '🛒', msg: '<strong>Sipho</strong> in Johannesburg ordered <strong>Twin & Earth 2.5mm</strong>' },
      { icon: '👁️', msg: '<strong>14 people</strong> are viewing this page right now' },
      { icon: '🛒', msg: '<strong>Johan</strong> in Cape Town ordered a <strong>Distribution Board 8-way</strong>' },
      { icon: '⚡', msg: 'New stock: <strong>Armoured Cable 16mm²</strong> 50m rolls just landed' },
      { icon: '🛒', msg: '<strong>Priya</strong> in Durban ordered a <strong>LED Floodlight 100W</strong>' },
      { icon: '🔥', msg: '<strong>Solar Inverter 5kW</strong> is trending — 7 sold today' },
      { icon: '🛒', msg: '<strong>Michael</strong> in Pretoria ordered <strong>MCB 32A Single Pole</strong>' },
      { icon: '⭐', msg: '<strong>Werner</strong> from East London just left a 5-star review' },
      { icon: '🛒', msg: '<strong>Thabo</strong> in Sandton ordered <strong>Armoured SWA Cable 16mm</strong>' },
      { icon: '🚚', msg: '<strong>Same-day dispatch</strong> available for Joburg orders placed before 2PM' }
    ];

    var wrap = document.createElement('div');
    wrap.className = 'live-activity';
    document.body.appendChild(wrap);

    var idx = 0, toast = null;

    function show() {
      if (toast) {
        toast.classList.remove('show');
        var t = toast;
        setTimeout(function () { t && t.remove(); }, 450);
        toast = null;
      }

      var item = activities[idx % activities.length];
      idx++;

      var el = document.createElement('div');
      el.className = 'live-activity-toast';
      el.innerHTML =
        '<div class="live-dot"></div>' +
        '<span class="live-icon">' + item.icon + '</span>' +
        '<span>' + item.msg + '</span>';
      wrap.appendChild(el);
      toast = el;

      requestAnimationFrame(function () {
        requestAnimationFrame(function () { toast && toast.classList.add('show'); });
      });

      setTimeout(function () {
        if (toast === el) {
          el.classList.remove('show');
          setTimeout(function () { el.remove(); if (toast === el) toast = null; }, 450);
        }
      }, 5500);
    }

    setTimeout(function () {
      show();
      setInterval(show, 11000 + Math.random() * 3000);
    }, 9000);
  }

  /* ─── SCROLL COUNTER ────────────────────────────────────────────── */
  function initCounters() {
    var els = document.querySelectorAll('[data-count]');
    if (!els.length) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        obs.unobserve(el);

        var target = parseInt(el.getAttribute('data-count'), 10);
        var suffix = el.getAttribute('data-suffix') || '';
        var dur = 1900;
        var start = performance.now();

        var parent = el.closest('.stat-item');
        if (parent) parent.classList.add('counted');

        function tick(now) {
          var p = Math.min((now - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(eased * target).toLocaleString() + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.25 });

    els.forEach(function (el) { obs.observe(el); });
  }

  /* ─── SCROLL REVEAL ─────────────────────────────────────────────── */
  function initScrollReveal() {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('[data-reveal], [data-reveal-stagger]').forEach(function (el) {
      obs.observe(el);
    });
  }

  /* ─── LIVE ERPAG ORDER COUNT ────────────────────────────────────── */
  function initLiveOrderCount() {
    var el = document.getElementById('bse-orders-count');
    if (!el) return;
    var workerUrl = el.getAttribute('data-live-url');
    if (!workerUrl || workerUrl.trim() === '') return;

    fetch(workerUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.ok && typeof data.count === 'number' && data.count > 0) {
          // Override the data-count with the live value and re-run counter
          el.setAttribute('data-count', data.count);
          el.setAttribute('data-suffix', '');
          el.textContent = '0';

          var target = data.count;
          var dur = 1900;
          var start = performance.now();
          var parent = el.closest('.stat-item');
          if (parent) parent.classList.add('counted');

          function tick(now) {
            var p = Math.min((now - start) / dur, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(eased * target).toLocaleString();
            if (p < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
        }
      })
      .catch(function () { /* silently keep fallback number */ });
  }

  /* ─── INIT ──────────────────────────────────────────────────────── */
  function init() {
    initScrollReveal();
    initCounters();
    initLiveOrderCount();
    initElectricCanvas();
    initTilt();
    initMagnetic();
    initLiveActivity();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
